import React from 'react';
import Card from '../../components/card';
import Title from '../../components/title';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
// import OrderTable from './components/order-table';
import { useNavigate } from 'react-router-dom';
import { isFullAccess } from '@/utils/permissionUtils';
import { AxiosResponse } from 'axios';
import { OrderMenu } from '@/configs/menuItems';
import { getPathSegment } from '@/utils/pathUtils';
import SubMenu from '@/components/menu/sub-menu';
import { IStockReserved } from '@/interfaces/reserved';
import { queryStockReserveds } from '@/adapters/reserved';
import StockReservedTable from './_components/reserved-table';

const Reserved = () => {
  const pathSegment = getPathSegment();
  const navigate = useNavigate();

  const { data, isLoading, refetch } = useQuery<
    AxiosResponse<IStockReserved[]>,
    Error
  >({
    queryKey: ['search-reserved'],
    queryFn: async () => await queryStockReserveds(),
  });

  const perFullAccess = isFullAccess();

  return (
    <>
      <SubMenu active={pathSegment} items={OrderMenu} />
      <Card>
        <Title title="จองสินค้า">
          <div className="flex justify-end gap-3">
            {perFullAccess && (
              <Button
                type="primary"
                onClick={() => navigate(`/reserved/create`)}
              >
                <PlusOutlined /> เพิ่มใหม่
              </Button>
            )}
          </div>
        </Title>
        <div className="flex flex-col gap-3">
          <StockReservedTable
            stockReserved={data?.data || []}
            loading={isLoading}
            onEditData={item => console.log(item)}
            onDelete={() => refetch()}
          />
        </div>
      </Card>
    </>
  );
};

export default Reserved;
